import { Card, Col, ListGroup, Row } from "react-bootstrap";
import axios from "axios";
import vs from '../../images/profile/payment.png';
import {Link} from 'react-router-dom';
//lg
import { useTranslation, initReactI18next } from 'react-i18next';
import i18n from 'i18next';

const Footer = () => {
  const { t } = useTranslation();
  var d = new Date();
  return (
    <div className="footer m-4 text-black">


{/* =========================================================
    SMART COPYRIGHT - DESKTOP/TABLET ONLY
========================================================= */}

<div className="rp-copyright-section">

  <div className="rp-copyright-inner">

    <div className="rp-copyright-left">

      <span className="rp-copyright-icon">
        <i className="fas fa-copyright"></i>
      </span>

      <p>
        {t("pro_footer_copyright")}{" "}
        <strong>{d.getFullYear()}</strong>
      </p>

    </div>


    <div className="rp-copyright-right">

      <span>
        <i className="fas fa-shield-alt"></i>
        Secure Platform
      </span>

      <span className="rp-copy-dot"></span>

      <span>
        <i className="fas fa-check-circle"></i>
        Holy Trust
      </span>

    </div>

  </div>

</div>


<style>{`

  /* =====================================================
     COPYRIGHT
  ===================================================== */

  .rp-copyright-section {
    width: 100%;

    margin-top: 25px;
    padding-top: 18px;

    border-top: 1px solid #e5ebe8;
  }


  .rp-copyright-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 20px;

    padding: 14px 18px;

    border: 1px solid #e6ece9;
    border-radius: 14px;

    background:
      linear-gradient(
        135deg,
        #f8fbfa 0%,
        #f1f7f5 100%
      );
  }


  /* LEFT */

  .rp-copyright-left {
    display: flex;
    align-items: center;

    gap: 10px;
  }


  .rp-copyright-icon {
    width: 35px;
    height: 35px;

    flex: 0 0 35px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 10px;

    background: #135846;

    color: #ffffff;

    font-size: 13px;
  }


  .rp-copyright-left p {
    margin: 0;

    color: #65716d;

    font-size: 14px;
    font-weight: 500;
  }


  .rp-copyright-left strong {
    color: #17241f;

    font-weight: 800;
  }


  /* RIGHT */

  .rp-copyright-right {
    display: flex;
    align-items: center;

    gap: 12px;

    color: #74817c;

    font-size: 12px;
    font-weight: 600;
  }


  .rp-copyright-right span {
    display: flex;
    align-items: center;

    gap: 6px;
  }


  .rp-copyright-right i {
    color: #135846;

    font-size: 11px;
  }


  .rp-copyright-right .rp-copy-dot {
    width: 4px;
    height: 4px;

    display: block;

    padding: 0;

    border-radius: 50%;

    background: #aeb9b5;
  }


  /* =====================================================
     MOBILE
     - Copyright completely hidden
     - Mobile footer area gets 30px top margin
  ===================================================== */

  @media (max-width: 767px) {

    .rp-copyright-section {
      display: none !important;
    }

    .mobilefutshow {
      margin-top: 30px !important;
    }

  }

`}</style>

















      <footer className="mobilefutshow rp-mobile-footer">

        <style>{`

          /* =====================================================
             MOBILE FOOTER
             Desktop hidden
          ===================================================== */

          .rp-mobile-footer {
            display: none;
          }


          /* =====================================================
             MOBILE ONLY
          ===================================================== */

          @media (max-width: 767px) {

            .rp-mobile-footer {
              position: fixed;

              left: 10px;
              right: 10px;
              bottom: 10px;

              display: block !important;

              height: 72px;

              padding: 6px;

              margin: 0 !important;

              border:
                1px solid
                rgba(19, 88, 70, 0.10);

              border-radius: 22px;

              background:
                rgba(255, 255, 255, 0.97);

              box-shadow:
                0 12px 35px
                rgba(23, 42, 35, 0.16);

              backdrop-filter:
                blur(16px);

              -webkit-backdrop-filter:
                blur(16px);

              z-index: 99999;
            }


            /* ===================================================
               NAV WRAPPER
            =================================================== */

            .rp-mobile-footer
            .footer-nav-wrapper {

              width: 100%;
              height: 100%;

              display: grid;

              grid-template-columns:
                repeat(4, 1fr);

              align-items: center;

              gap: 4px;

              padding: 0;

              margin: 0;
            }


            /* ===================================================
               SINGLE MENU
            =================================================== */

            .rp-mobile-footer
            .footer-nav-single {

              position: relative;

              height: 58px;

              display: flex;

              align-items: center;
              justify-content: center;

              padding: 0;

              margin: 0;

              border-radius: 16px;

              color: #6d7975 !important;

              text-decoration: none !important;

              transition:
                background 0.2s ease,
                color 0.2s ease,
                transform 0.2s ease;
            }


            .rp-mobile-footer
            .footer-nav-single:hover {

              background: #f1f7f5;

              color: #135846 !important;

              text-decoration: none;
            }


            .rp-mobile-footer
            .footer-nav-single:active {

              transform: scale(0.96);
            }


            /* ===================================================
               MENU CONTENT
            =================================================== */

            .rp-mobile-footer
            .menu-wrapper {

              width: 100%;
              height: 100%;

              display: flex;

              flex-direction: column;

              align-items: center;
              justify-content: center;

              gap: 4px;

              padding: 4px;

              margin: 0;
            }


            /* ===================================================
               ICON
            =================================================== */

            .rp-mobile-footer
            .rp-mobile-menu-icon {

              width: 32px;
              height: 30px;

              display: flex;

              align-items: center;
              justify-content: center;

              border-radius: 10px;

              color: #66736e;

              font-size: 19px;

              line-height: 1;

              transition:
                background 0.2s ease,
                color 0.2s ease,
                transform 0.2s ease;
            }


            .rp-mobile-footer
            .footer-nav-single:hover
            .rp-mobile-menu-icon {

              color: #135846;

              transform:
                translateY(-1px);
            }


            /* ===================================================
               TEXT
            =================================================== */

            .rp-mobile-footer
            .rp-mobile-menu-text {

              display: block;

              color: #65716d;

              font-size: 11px;

              font-weight: 700;

              line-height: 1.2;

              white-space: nowrap;

              transition:
                color 0.2s ease;
            }


            .rp-mobile-footer
            .footer-nav-single:hover
            .rp-mobile-menu-text {

              color: #135846;
            }


            /* ===================================================
               DEPOSIT - SPECIAL BUTTON
            =================================================== */

            .rp-mobile-footer
            .rp-deposit-menu
            .rp-mobile-menu-icon {
              color: #66736e;
            }


            .rp-mobile-footer
            .rp-deposit-menu:hover
            .rp-mobile-menu-icon {

              color: #ffffff;

              transform:
                translateY(-2px);

              box-shadow:
                0 7px 18px
                rgba(19, 88, 70, 0.28);
            }


            /* ===================================================
               PROFILE
            =================================================== */

            .rp-mobile-footer
            .rp-profile-menu
            .rp-mobile-menu-icon {

              background:
                #edf6f3;

              color:
                #66736e;
            }


            /* ===================================================
               TOP INDICATOR
            =================================================== */

            .rp-mobile-footer
            .footer-nav-single::before {

              content: "";

              position: absolute;

              top: 0;
              left: 50%;

              width: 0;
              height: 3px;

              transform:
                translateX(-50%);

              border-radius:
                0 0 10px 10px;

              background:
                #135846;

              transition:
                width 0.2s ease;
            }


            .rp-mobile-footer
            .footer-nav-single:hover::before {

              width: 24px;
            }

          }


          /* =====================================================
             SMALL MOBILE
          ===================================================== */

          @media (max-width: 420px) {

            .rp-mobile-footer {

              left: 7px;
              right: 7px;
              bottom: 0px;

              height: 68px;

              padding: 5px;

              border-radius: 19px;
            }


            .rp-mobile-footer
            .footer-nav-single {

              height: 56px;

              border-radius: 14px;
            }


            .rp-mobile-footer
            .rp-mobile-menu-icon {

              width: 30px;
              height: 28px;

              font-size: 18px;
            }


            .rp-mobile-footer
            .rp-mobile-menu-text {

              font-size: 10px;
            }

          }


          /* =====================================================
             VERY SMALL MOBILE
          ===================================================== */

          @media (max-width: 350px) {

            .rp-mobile-footer {

              left: 5px;
              right: 5px;

              padding: 4px;
            }


            .rp-mobile-footer
            .footer-nav-wrapper {

              gap: 1px;
            }


            .rp-mobile-footer
            .rp-mobile-menu-icon {

              font-size: 17px;
            }


            .rp-mobile-footer
            .rp-mobile-menu-text {

              font-size: 9px;
            }

          }

        `}</style>


        <div className="footer-nav-wrapper">


          {/* ================================
              HOME
          ================================= */}

          <Link
            className="footer-nav-single"
            to="/"
          >

            <div className="menu-wrapper">

              <div className="rp-mobile-menu-icon">

                <i className="fas fa-home"></i>

              </div>

              <span className="rp-mobile-menu-text">

                Home

              </span>

            </div>

          </Link>


          {/* ================================
              BOOKING
          ================================= */}

          <Link
            className="footer-nav-single"
            to="/smart-module"
          >

            <div className="menu-wrapper">

              <div className="rp-mobile-menu-icon">

                <i className="fas fa-map-marked-alt"></i>

              </div>

              <span className="rp-mobile-menu-text">

                Booking

              </span>

            </div>

          </Link>


          {/* ================================
              DEPOSIT
          ================================= */}

          <Link
            className="footer-nav-single rp-deposit-menu"
            to="/deposit"
          >

            <div className="menu-wrapper">

              <div className="rp-mobile-menu-icon">

                <i className="fas fa-wallet"></i>

              </div>

              <span className="rp-mobile-menu-text">

                Deposit

              </span>

            </div>

          </Link>


          {/* ================================
              PROFILE
          ================================= */}

          <Link
            className="footer-nav-single rp-profile-menu"
            to="/app-profile"
          >

            <div className="menu-wrapper">

              <div className="rp-mobile-menu-icon">

                <i className="fas fa-user-circle"></i>

              </div>

              <span className="rp-mobile-menu-text">

                Profile

              </span>

            </div>

          </Link>


        </div>

      </footer>


    </div>
  );
};

export default Footer;
